<template>
  <path
    fill="currentColor"
    d="M1.25 5C1.25 4.65482 1.52982 4.375 1.875 4.375L14.1277 4.375C16.6825 4.375 18.75 6.44623 18.75 9V11C18.75 13.5538 16.6825 15.625 14.1277 15.625L1.875 15.625C1.52982 15.625 1.25 15.3452 1.25 15C1.25 14.6548 1.52983 14.375 1.875 14.375L14.1277 14.375C15.9911 14.375 17.5 12.8645 17.5 11V9C17.5 7.1355 15.9911 5.625 14.1277 5.625L1.875 5.625C1.52982 5.625 1.25 5.34518 1.25 5Z" />
</template>
